import { getAximaDomainDetail } from "../../http/aximaHttp/AximaDomainHttp";
import { createPortal } from "react-dom"
import Div from "../Div";
import FormButton from "../FormButton";
import { useCallback, useEffect, useState } from "react";
import { role } from "../../util/validation";
import AddAximaLicenseModal from "./AddAximaLicenseModal";
import EditDomainModal from "./EditDomainModal";


function AximaDomainDetailModal({ domain_id, handleClicked, ...props }) {

    const [subscriptionList, setSubscriptionList] = useState(false)
    const [addLicenseModal, setAddLicenseModal] = useState(false)
    const [editModal, setEditModal] = useState(false)

    const getAximaProducts = useCallback(async () => {
        const googleSubscriptionResponse = await getAximaDomainDetail(domain_id)
        if (googleSubscriptionResponse) {

            setSubscriptionList(googleSubscriptionResponse.domains)
        }
        else {
            alert('No Subscription for this Domain')
        }


    }, [domain_id])

    useEffect(() => {
        getAximaProducts()
    }, [getAximaProducts])

    function handleClose() {
        handleClicked(false);
    }

    function handleAddLicense(domain_name, product_name, user_count, subscription_id) {
        setAddLicenseModal({
            'domain_name': domain_name,
            'product_name': product_name,
            'user_count': user_count,
            'subscription_id' : subscription_id
        })
    }

    function handleEditDomain(domain_name, subscription_id) {
         setEditModal({'subscription_id' : subscription_id,
            'domain_name' : domain_name
        })
    }

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    {addLicenseModal ? <AddAximaLicenseModal domain={addLicenseModal} show={true.toString()} open handleClicked={setAddLicenseModal} /> : null}
                    {editModal ? <EditDomainModal domain_name={editModal} show={true.toString()} open handleClicked={setEditModal} /> : null}
                    <dialog {...props}
                    // style={{ zIndex: '1', maxWidth: '85%' }}
                    >
                        
                        <Div className="form-group">
                            Add Axima Domain
                        </Div>
                        <Div className='scroll-container'
                            style={{
                                overflowY: "auto",
                                height: "604px",
                                width: "100%",
                                border: "1px solid #000",
                                padding: "10px",
                            }}>

                            {subscriptionList.length > 0 ? <table className="table" border="1">
                                <thead>
                                    <tr>
                                        <th>Tcket Number</th>
                                        <th>Name</th>
                                        <th>Company Name</th>
                                        <th>Product Name</th>
                                        <th>User Count</th>
                                        <th>Renewal Date</th>
                                        {role === 'SALESC' || role === 'ADEPLOY' ? <th>Action</th> : null}
                                    </tr>
                                </thead>
                                <tbody id="tableBody">
                                    {subscriptionList.map((subscriptionList) => <>
                                        <tr key= {subscriptionList.axima_subscription_id} >
                                            <td>{subscriptionList.ticket_number}</td>
                                            <td>{subscriptionList.name}</td>
                                            <td>{subscriptionList.companyName}</td>
                                            <td>{subscriptionList.axima_product_name}</td>
                                            <td>{subscriptionList.user_count}</td>
                                            <td>{subscriptionList.renewal_date}</td>
                                            <th>
                                               {role === 'AXSUP' && <FormButton className="btn btn-primary btn-sm"
                                                onClick = {() => {handleAddLicense(subscriptionList.domain_name, 
                                                    subscriptionList.axima_product_name, subscriptionList.user_count,
                                                    subscriptionList.axima_subscription_id)}}
                                                >
                                                    Add License
                                                </FormButton>}
                                               
                                                {role === 'SALESC' || role === 'ADEPLOY' ? <FormButton className="btn btn-primary btn-sm"
                                                onClick = {() => {handleEditDomain(subscriptionList.domain_name, 
                                                    subscriptionList.axima_subscription_id)}}
                                                >
                                                    Edit Domain
                                                </FormButton>: null}
                                            </th>
                                        </tr>
                                    </>)
                                    }
                                </tbody>
                            </table>
                                : null}

                            <Div className='row' style={{ marginTop: '10px' }}>
                               {role === 'SALESC' && <Div className='col-sm-6'>
                                    <FormButton type='submit' style={{ margin: '2px' }}
                                        className="btn btn-primary submit-btn btn-block">Add Subscription</FormButton>
                                </Div>}
                                <Div className='col-sm-6'>
                                    <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                </Div>
                            </Div>
                        </Div>
                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }
        </>
    )
}

export default AximaDomainDetailModal;